module.exports = __webpack_public_path__ + "img/visa-card.c7375f9c.png";